// OpenAgents Control — the open-source project behind this site.
//
// This is the free thing. It replaced four generic markdown checklists that
// anyone could have written; this is a real system people install and run,
// and it is the strongest evidence on the site that the paid session is worth
// booking. Everything here is verifiable at the repo URL.
//
// Figures below were read from the GitHub API on 2026-09-09. They are
// rounded DOWN so they stay true as the repo grows — refresh them
// occasionally rather than letting them drift upward.

export const OAC = {
  name: 'OpenAgents Control',
  short: 'OAC',
  repoUrl: 'https://github.com/darrenhinde/OpenAgentsControl',
  license: 'MIT',
  stars: '4,800+',
  forks: '390+',
  tagline: 'Control your AI patterns. Get repeatable results.',
  description:
    'An agent framework for plan-first development: the agent proposes a plan, you approve it, then it executes step by step with validation and review built in. Multi-language, model-agnostic, and free.',
  installCommand:
    'curl -fsSL https://raw.githubusercontent.com/darrenhinde/OpenAgentsControl/main/install.sh | bash -s developer',
  prerequisite: 'Needs the OpenCode CLI — the installer sets it up if you do not have it.',
} as const

/**
 * The six stages, taken from the repo README's own Example Workflow. These
 * replaced four prose bullets that were describing the same pipeline in
 * words — three of them said Discover, Propose/Approve and Execute/Validate
 * without ever showing that Approve is a gate you stand in.
 *
 * Order matters and so does `gate`: it is the only stage that is the person
 * rather than the agent, and the diagram leans on that to make its point.
 * Deliberately no per-stage timings — they are right on the repo and read as
 * product spec on a page selling ninety minutes of someone's time.
 */
export const OAC_STAGES = [
  { name: 'Discover', note: 'Reads the patterns already in your repo' },
  { name: 'Propose', note: 'The whole plan, written out' },
  { name: 'Approve', note: 'Your call. Nothing written yet.', gate: true },
  { name: 'Execute', note: 'One component at a time, checked each step' },
  { name: 'Validate', note: 'Tests and a security review' },
  { name: 'Ship', note: 'Nothing left to refactor' },
] as const

/** The fourth of the old bullets, which the diagram has no room for. */
export const OAC_PLATFORMS = 'TypeScript · Python · Go · Rust · any model'
